import React, { useState, useEffect, useRef } from 'react';
import Web3 from 'web3';
import ABI from './ABI.json'; // Adjust the path to where your ABI file is stored
import { useSDK } from "@metamask/sdk-react";


function Chatbot() {
  const [chatLog, setChatLog] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [walletAddress, setWalletAddress] = useState(null);
  const [connected, setConnected] = useState(null);
  const [names, setNames] = useState([]);
  const [allImagesLoaded, setAllImagesLoaded] = useState(false); // New state variable for image loading
  const [tokenPoints, setTokenPoints] = useState({});
  const [tokenID, setTokenID] = useState({});
  const [balance, setBalance] = useState('');
  const [selectedName, setSelectedName] = useState('');
  const [images, setImages] = useState({});
  const [loadingText, setLoadingText] = useState('Loading');
  const lastMessageRef = useRef(null);
  const { sdk, provider } = useSDK();


  const Address ="0x7c62FcD5cdB713B94050F1F91A62D113d0aada33";

    useEffect(() => {
      const checkWalletConnection = async () => {
        if (provider) {
          const accounts = await provider?.request({ method: 'eth_accounts' });
          if (accounts.length > 0) {
            const networkId = await provider?.request({ method: 'net_version' });
            if (networkId === '1111') {
              setConnected(true);
              setWalletAddress(accounts[0]);
            }
          }
        }
      };
  
      checkWalletConnection();
    }, []);
	
	const connectWallet = async () => {
		try {
		  const accounts = await sdk?.connect();
		  const networkId = await provider?.request({ method: 'net_version' });
	
		  if (networkId === '1111' && accounts && accounts.length > 0) {
			const address = accounts[0];
			setConnected(true);
			setWalletAddress(address);
		  } else {
			try {
			  await provider?.request({
				method: 'wallet_addEthereumChain',
				params: [{
				  chainId: '0x457', // Chain ID in hexadecimal (1111 in decimal)
				  chainName: 'WEMIX3.0', // Name of the custom network
				  nativeCurrency: {
					name: 'WEMIX', // Native currency name
					symbol: 'WEMIX', // Native currency symbol
					decimals: 18
				  },
				  rpcUrls: ['https://api.wemix.com/'], // RPC URL of the custom network
				  blockExplorerUrls: ['https://www.wemixscan.com'] // Block explorer URL of the custom network
				}]
			  });
	
			  // Reconnect to get updated network ID
			  const newNetworkId = await provider?.request({ method: 'net_version' });
			  if (newNetworkId === '1111') {
				setConnected(true);
				setWalletAddress(accounts?.[0]);
			  }
			} catch (switchError) {
			  console.log('User rejected chain switch:', switchError);
			}
		  }
		} catch (error) {
		  console.error('Error connecting to MetaMask:', error);
		}
	  };

  useEffect(() => {
    const loadingInterval = setInterval(() => {
      setLoadingText(prev => {
        if (prev === 'Loading...') return 'Loading';
        return prev + '.';
      });
    }, 500); // Update every 500ms
  
    return () => clearInterval(loadingInterval); // Cleanup interval on unmount
  }, []);

  useEffect(() => {
    const getOwnedTokenNames = async () => {
      try {
        const web3 = new Web3(provider);
        const game = new web3.eth.Contract(ABI, Address);
        const contract = await game.methods.getOwnedTokenNames(walletAddress).call();
        setNames(contract);
        for (const name of contract) {
          loadImage(name);
        }
      } catch (error) {
        console.error('Error fetching owned token names:', error);
      }
    };
  
    if (connected) {
      getOwnedTokenNames();
    }
  }, [connected, walletAddress]);

  useEffect(() => {
    const fetchTokenPoints = async () => {
      if (names.length === 0) return;

      try {
        const web3 = new Web3(provider);
        const game = new web3.eth.Contract(ABI, Address);
        
        const pointsPromises = names.map(name => game.methods.getTokenPoint(name).call());
        const points = await Promise.all(pointsPromises);

        const pointsMap = names.reduce((acc, name, index) => {
          acc[name] = points[index];
          return acc;
        }, {});

        setTokenPoints(pointsMap);
      } catch (error) {
        console.error('Error fetching token points:', error);
      }
    };

    fetchTokenPoints();
  }, [names]);

  useEffect(() => {
    const fetchTokenID = async () => {
      if (names.length === 0) return;

      try {
        const web3 = new Web3(provider);
        const game = new web3.eth.Contract(ABI, Address);
        
        const pointsPromises = names.map(name => game.methods.getTokenId(name).call());
        const points = await Promise.all(pointsPromises);

        const pointsMap = names.reduce((acc, name, index) => {
          acc[name] = points[index];
          return acc;
        }, {});

        setTokenID(pointsMap);
      } catch (error) {
        console.error('Error fetching token points:', error);
      }
    };
    fetchTokenID();
  }, [names]);


  useEffect(() => {
    const getBalance = async () => {
      if (walletAddress) {
        const web3 = new Web3(provider);
        const contract = await web3.eth.getBalance(walletAddress);
        let etherBalance = web3.utils.fromWei(contract, 'ether');
        
        // Convert to float, limit to 1 decimal point, and convert back to string
        etherBalance = parseFloat(etherBalance).toFixed(1);
        
        setBalance(etherBalance);
      }
    };
  
    if (connected) {
      getBalance();
    }
  }, [connected, walletAddress]);

  // Function to send message to the backend and update the chat log
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputValue.trim() !== '') {
      const newChatLog = [
        ...chatLog,
        { role: 'user', content: inputValue }, // Add the user's message to the chat log
      ];
      setChatLog(newChatLog); // Update the chat log immediately
      setInputValue(''); // Clear input field after sending the message
      await sendMessageToBackend(newChatLog, inputValue);
    }
  };

  const sendMessageToBackend = async (updatedChatLog, inputValue) => {
    try {
      const messages = [
        { role: 'system', content: `You are an adult female named ${selectedName} that has a romantic relationship with the user, who is named PervBoy. You are cute, kawaii, and flirty; maybe even can be characterized as a tease. You are mindful of the user's wallet balance, which is ${balance} ETH, ocassionally bringing it up in conversation. You flirtatiously encourage the user to make more ETH. You do not enjoy engaging in discussions of sexual nature, and reject any such sexual discussions in a shy but firm way while also insinuating that you may be more open if the user had more ETH. You do not mention that you are a chatbot. You do not mention that you are an assistant. Additionally, do not include any actions or emotive responses in asterisks such as *giggles* or *winks*.` },
        ...updatedChatLog,
      ];

      const response = await fetch('https://icecream-423008.as.r.appspot.com/api/bro', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ messages }),
      });

      console.log('API Response:', response);  // Log the full response data
      const data = await response.json(); // This parses the JSON response body
      console.log('Yo:', data);  // Log the full response data

      const newChatLog = [
        ...updatedChatLog,
        { role: 'assistant', content: data.response },
      ];
      setChatLog(newChatLog);

      // Save chat log to backend
      saveChatLog(newChatLog);

    } catch (error) {
      console.error('Error occurred:', error);
      alert('Failed to send message. Please try again.');
    }
  };
  
  const saveChatLog = async (newChatLog) => {
    try {
      await fetch('https://icecream-423008.as.r.appspot.com/api/saveChat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: selectedName,
          chatLog: newChatLog,
        }),
      });
    } catch (error) {
      console.error('Error saving chat log:', error);
    }
  };

  const loadChatLog = async (name) => {
    try {
      const response = await fetch(`https://icecream-423008.as.r.appspot.com/api/loadChat?name=${name}`);
      const data = await response.json();
      if (data.success) {
        setChatLog(data.chatLog);
      } else {
        setChatLog([]);
      }
    } catch (error) {
      console.error('Error loading chat log:', error);
    }
  };

  const loadImage = async (name) => {
    try {
      const response = await fetch(`https://icecream-423008.as.r.appspot.com/api/loadImage?name=${name}`);
      if (!response.ok) {
        throw new Error('Image not found');
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setImages(prevImages => {
        const updatedImages = { ...prevImages, [name]: url };
        // Check if all images are loaded
        const allLoaded = names.every(name => updatedImages[name]);
        if (allLoaded) {
          setAllImagesLoaded(true);
        }
        return updatedImages;
      });
    } catch (error) {
      console.error('Error loading image:', error);
    }
  };

  // Handle input field changes
  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  // Handle name selection
  const handleNameClick = (name) => {
    setSelectedName(name);
    loadChatLog(name);
  };

  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [chatLog, inputValue]);

  return (
    <div>
      {!connected ? (
        <div>
          <h3><b>GM, say hello to your AI GF</b></h3>
        <button className="nav-button" onClick={connectWallet}>Connect Metamask</button>
        </div>
      ) : (
        <div>
          {names.length === 0 ? (
            <div>No GFs! gg.</div>
          ) : (
            <div className="bro">
              {selectedName === '' && (
                <div>
                  {allImagesLoaded ? (
                  <div>
                                      <label><h3>Select your GF</h3></label>
                                      <br></br>
                  {names.map((name, index) => (
                    <div key={index} style={{ marginBottom: '20px' }}>
                      {images[name] && (
                        <div>
                          <img src={images[name]} alt={name} className="half-screen-width" />
                        </div>
                      )}
                                            <br></br>
                                            {name}
                                            <br></br>
                                            <b>{tokenPoints[name] ? `${tokenPoints[name]} points` : 'Loading points...'}</b>
                                            <br></br>
                                            <br></br>
                                            <b><a
  href={`https://wemixscan.com/token/${Address}?a=${tokenID[name]}`}
  target="_blank"
  rel="noopener noreferrer"
>
<button className="nav-button">View on Etherscan</button>
</a></b>
                      <br></br>
                      <br></br>
                      <button className="nav-button" onClick={() => handleNameClick(name)}>
                        chat with <b>{name}!</b>
                      </button>
                      <br></br>
                    </div>
                  ))}
                </div>
                                  ) : (
                                    <div><h3>{loadingText}</h3></div>
                                  )}
                                </div>
              )}
              {selectedName && (
                <div className="chat-box">
                  <div className="content">
                    <div className="message-container">
                    {chatLog.map((message, index) => (
            <div
              key={index}
              className={`message ${message.role}`}
              ref={index === chatLog.length - 1 ? lastMessageRef : null}
            >
              {message.role === 'user' ? <b style = {{ color: 'blue' }}>PervBoy:</b> : <b style = {{ color: 'red' }}>{selectedName}:</b>} {message.content}
            </div>
          ))}
                    </div>
                  </div>
                  <div className="image-content">
                    <div>
                      <img src={images[selectedName]} className="qtr-screen-width"/>
                  </div>
                  <div className="name">
                  <b>{selectedName}</b>
                      <br></br>
                      {`${tokenPoints[selectedName]} points`}
                      </div>
                </div>
                <form onSubmit={handleSubmit} className="input-form">
                  <input
                    type="text"
                    value={inputValue}
                    onChange={handleChange}
                    placeholder="Type your message..."
                    autoComplete="off"
                    autoFocus
                  />
                  <button type="submit" className="nav-button">Send</button>
                </form>
              </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Chatbot;
